<div class="message-text" [innerHTML]="message.content.text"></div>
